export default __webpack_public_path__ + "static/media/shopping-mall.07ff3c0e.svg";